import { memo } from "react";
import logo from "../../assets/images/logo-dark.png";
import { Link } from "react-router-dom";
import CheckoutStep from "../../features/Checkout/CheckoutStep/CheckoutStep";
import "../../assets/styles/components/Navbars/Cartheader.css";

function cartHeader(){
  return(
      <> 
         <section className="navheader mb-4 cart-headers"> 
            <div className="cartheaderSection"> 
              <div style={{ display:"flex", alignItems:"center"}}> <Link to="/"> <img src={logo} alt="logo" loading="Lazy" width={160}/> </Link> </div>
                <div> <CheckoutStep/> </div>
                <div className="Secure100"> 
                    <i className="bi bi-shield-fill-check" style={{ color:"#14cda8", fontSize:"24px"}}></i> 100% SECURE
                </div>
            </div>   
         </section> 
      </>
  )
}
export default memo(cartHeader);